import { bus } from "@/common/buses/popups/bus";
import { IOpenPopupEvent } from "@/common/buses";

import {
  IAddToNichePopupProps,
  IReportPopupProps,
  IAddToCollectionPopupProps,
  ICreateNewCollectionPopupProps,
  IEditNichePopupContainerProps,
  IEditNichesDialogProps,
  IGifPreferencePopupProps,
  IShareGifMenuProps,
  IMoreMenuContainerProps,
  INicheMoreMenuContainerProps,
  IEditGifPopupProps,
  IAddDescriptionPopup,
  IAddToNicheConfirm,
  IVerificationPopupProps,
  IGifNichesPopup,
  IProfileOptions
} from "@/common/buses/popups/popup-types";

import { PopupsEnum } from "./popups";

type OpenAddNicheEvent = IOpenPopupEvent & IAddToNichePopupProps;
type OpenReportPopupEvent = IOpenPopupEvent & IReportPopupProps;
type OpenAddCollectionPopupEvent = IOpenPopupEvent & IAddToCollectionPopupProps;
type OpenCreateNewCollectionPopupEvent = IOpenPopupEvent & ICreateNewCollectionPopupProps;
type OpenEditNichePopupEvent = IOpenPopupEvent & IEditNichePopupContainerProps;
type OpenEditGifNichesPopupEvent = IOpenPopupEvent & IEditNichesDialogProps;
type OpenEditGifPreferencesPopupEvent = IOpenPopupEvent & IGifPreferencePopupProps;
type OpenShareGifMenuEvent = IOpenPopupEvent & IShareGifMenuProps;
type OpenMoreMenuEvent = IOpenPopupEvent & IMoreMenuContainerProps;
type OpenNicheMoreMenuEvent = IOpenPopupEvent & INicheMoreMenuContainerProps;
type OpenEditGifPopupEvent = IOpenPopupEvent & IEditGifPopupProps;
type OpenAddDescriptionPopupEvent = IOpenPopupEvent & IAddDescriptionPopup;
type OpenAddToNicheConfirmEvent = IOpenPopupEvent & IAddToNicheConfirm;
type OpenVerificationPopupEvent = IOpenPopupEvent & IVerificationPopupProps;
type OpenGifNichesPopupEvent = IOpenPopupEvent & IGifNichesPopup;
type OpenProfileOptionsEvent = IOpenPopupEvent & IProfileOptions;

export const onOpenPreferencesPopup = () => {
  bus.emit("open", { name: PopupsEnum.Preferences });
};

export const onClosePreferencesPopup = () => {
  bus.emit("close", { name: PopupsEnum.Preferences });
};

export const onOpenChangedEmailPopup = () => {
  bus.emit("open", { name: PopupsEnum.ChangedEmail });
};

export const onCloseChangedEmailPopup = () => {
  bus.emit("close", { name: PopupsEnum.ChangedEmail });
};

export const onOpenAddNichePopup = (props: IAddToNichePopupProps) => {
  const params: OpenAddNicheEvent = { name: PopupsEnum.AddNiche, ...props };
  bus.emit("open", params);
};

export const onCloseAddNichePopup = () => {
  bus.emit("close", { name: PopupsEnum.AddNiche });
};

export const onOpenReportPopup = (props: IReportPopupProps) => {
  const params: OpenReportPopupEvent = { name: PopupsEnum.Report, ...props };
  bus.emit("open", params);
};

export const onCloseReportPopup = () => {
  bus.emit("close", { name: PopupsEnum.Report });
};

export const onOpenAddCollectionPopup = (props: IAddToCollectionPopupProps) => {
  const params: OpenAddCollectionPopupEvent = { name: PopupsEnum.AddCollection, ...props };
  bus.emit("open", params);
};

export const onCloseAddCollectionPopup = () => {
  bus.emit("close", { name: PopupsEnum.AddCollection });
};

export const onOpenCreateNewCollectionPopup = (props: ICreateNewCollectionPopupProps) => {
  const params: OpenCreateNewCollectionPopupEvent = { name: PopupsEnum.CreateCollection, ...props };
  bus.emit("open", params);
};

export const onCloseCreateNewCollectionPopup = () => {
  bus.emit("close", { name: PopupsEnum.CreateCollection });
};

export const onOpenEditNichePopup = (props: IEditNichePopupContainerProps) => {
  const params: OpenEditNichePopupEvent = { name: PopupsEnum.EditNiche, ...props };
  bus.emit("open", params);
};

export const onCloseEditNichePopup = () => {
  bus.emit("close", { name: PopupsEnum.EditNiche });
};

export const onOpenEditGifNichesPopup = (props: IEditNichesDialogProps) => {
  const params: OpenEditGifNichesPopupEvent = { name: PopupsEnum.EditGifNiches, ...props };
  bus.emit("open", params);
};

export const onCloseEditGifNichesPopup = () => {
  bus.emit("close", { name: PopupsEnum.EditGifNiches });
};

export const onOpenEditGifPreferencesPopup = (props: IGifPreferencePopupProps) => {
  const params: OpenEditGifPreferencesPopupEvent = { name: PopupsEnum.EditGifPreferences, ...props };
  bus.emit("open", params);
};

export const onCloseEditGifPreferencesPopup = () => {
  bus.emit("close", { name: PopupsEnum.EditGifPreferences });
};

export const onOpenShareGifMenu = (props: IShareGifMenuProps) => {
  const params: OpenShareGifMenuEvent = { name: PopupsEnum.ShareGif, ...props };
  bus.emit("open", params);
};

export const onCloseShareGifMenu = () => {
  bus.emit("close", { name: PopupsEnum.ShareGif });
};

export const onOpenMoreMenu = (props: IMoreMenuContainerProps) => {
  const params: OpenMoreMenuEvent = { name: PopupsEnum.MoreMenu, ...props };
  bus.emit("open", params);
};

export const onCloseMoreMenu = () => {
  bus.emit("close", { name: PopupsEnum.MoreMenu });
};

export const onOpenNicheMoreMenu = (props: INicheMoreMenuContainerProps) => {
  const params: OpenNicheMoreMenuEvent = { name: PopupsEnum.NicheMoreMenu, ...props };
  bus.emit("open", params);
};

export const onCloseNicheMoreMenu = () => {
  bus.emit("close", { name: PopupsEnum.NicheMoreMenu });
};

export const onOpenEditGifPopup = (props: IEditGifPopupProps) => {
  const params: OpenEditGifPopupEvent = { name: PopupsEnum.EditGif, ...props };
  bus.emit("open", params);
};

export const onCloseEditGifPopup = () => {
  bus.emit("close", { name: PopupsEnum.EditGif });
};

export const onOpenAddToNicheSuccessPopup = () => {
  bus.emit("open", { name: PopupsEnum.AddToNicheSuccess });
};

export const onCloseAddToNicheSuccessPopup = () => {
  bus.emit("close", { name: PopupsEnum.AddToNicheSuccess });
};

export const onOpenAddDescriptionPopup = (props: IAddDescriptionPopup) => {
  const params: OpenAddDescriptionPopupEvent = { name: PopupsEnum.AddDescriptionPopup, ...props };
  bus.emit("open", params);
};

export const onCloseAddDescriptionPopup = () => {
  bus.emit("close", { name: PopupsEnum.AddDescriptionPopup });
};

export const onOpenVerificationPopup = (props: IVerificationPopupProps) => {
  const params: OpenVerificationPopupEvent = { name: PopupsEnum.Verification, ...props };
  bus.emit("open", params);
};

export const onCloseVerificationPopup = () => {
  bus.emit("close", { name: PopupsEnum.Verification });
};

export const onOpenGifNichesPopup = (props: IGifNichesPopup) => {
  const params: OpenGifNichesPopupEvent = { name: PopupsEnum.GifNiches, ...props };
  bus.emit("open", params);
};

export const onCloseGifNichesPopup = () => {
  bus.emit("close", { name: PopupsEnum.GifNiches });
};

export const onOpenProfileOptions = (props: IProfileOptions) => {
  const params: OpenProfileOptionsEvent = { name: PopupsEnum.ProfileOptions, ...props };
  bus.emit("open", params);
};

export const onCloseProfileOptions = () => {
  bus.emit("close", { name: PopupsEnum.ProfileOptions });
};

export const onOpenDeleteAccount = () => {
  bus.emit("open", { name: PopupsEnum.DeleteAccount });
};

export const onCloseDeleteAccount = () => {
  bus.emit("close", { name: PopupsEnum.DeleteAccount });
};

export const onOpenAddToNicheConfirm = (props: IAddToNicheConfirm) => {
  const params: OpenAddToNicheConfirmEvent = { name: PopupsEnum.AddToNicheConfirm, ...props };
  bus.emit("open", params);
};

export const onCloseAddToNicheConfirm = () => {
  bus.emit("close", { name: PopupsEnum.AddToNicheConfirm });
};

export const onOpenCreateNichePopup = () => {
  bus.emit("open", { name: PopupsEnum.CreateNiche });
};

export const onCloseCreateNichePopup = () => {
  bus.emit("close", { name: PopupsEnum.CreateNiche });
};

export const onOpenCaptchaPopup = () => {
  bus.emit("open", { name: PopupsEnum.CaptchaPopup });
};

export const onCloseCaptchaPopup = () => {
  bus.emit("close", { name: PopupsEnum.CaptchaPopup });
};

export const onOpenAgeDisclaimerPopup = () => {
  bus.emit("open", { name: PopupsEnum.AgeDisclaimer });
};

export const onCloseAgeDisclaimerPopup = () => {
  bus.emit("close", { name: PopupsEnum.AgeDisclaimer });
};
